import { useState, useEffect } from 'react';
import axios from 'axios';

export const PERIODES = [{ v: 7, l: '7 jours' }, { v: 30, l: '30 jours' }, { v: 0, l: 'Tout' }];

export const dateFr = (d) => (d ? new Date(d).toLocaleDateString('fr-FR') : '—');

// Récap chargé pour une période (jours = 0 : tout)
export const useRecap = (url, jours) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    axios.get(url, { params: { jours } }).then(r => setData(r.data)).catch(() => setData({ erreur: true }));
  }, [url, jours]);
  return data;
};

export const PeriodeTabs = ({ value, onChange, testId }) => (
  <div className="inline-flex rounded-lg border border-slate-200 bg-white p-1" role="tablist" data-testid={testId}>
    {PERIODES.map(p => (
      <button key={p.v} type="button" onClick={() => onChange(p.v)} role="tab" aria-selected={value === p.v}
        className={`px-3 py-1 text-xs font-medium rounded-md transition-colors ${value === p.v ? 'bg-[#0F172A] text-white' : 'text-slate-600 hover:bg-slate-100'}`}
        data-testid={`${testId}-${p.v}`}>
        {p.l}
      </button>
    ))}
  </div>
);

export const Vide = ({ children }) => <p className="text-sm text-slate-500 py-6 text-center">{children}</p>;
